import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { SlideTypeLinesService } from '@app/services/slide-type-lines.service';
import { ObjectGroupService } from '@app/services/object-group-lines.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LINE_AUTO_CONDITIONS, LINE_AUTO_SOURCES } from '@app/constants/line-auto-options';
import { TIMELINE_MARKER_OPTIONS } from '@app/constants/timeline-marker-options';
import { UnsavedChangesService } from '@app/services/unsaved-changes.service';
import { TemplateService } from '@app/services/template.service';
//import { slideType } from '@app/models/slideType.model';

@Component({
  selector: 'app-slide-type-lines',
  templateUrl: './slide-type-lines.component.html',
  styleUrl: './slide-type-lines.component.scss'
})

export class SlideTypeLinesComponent implements OnInit {

  
  SlideTypeLines!: FormGroup;
  stTypes: any[] = [];
sourceTypes: any[] = [];
shapeTypes: any[] = [];
exitanimTypes: any[] = [];
entryanimTypes: any[] = [];
textalignTypes: any[] = [];
shapeBorderTypes: any[] = [];
shapeShadowTypes: any[] = [];
  readingMaterialTypes: { ValidVal: string }[] = [];
  /** Object groups for OBJGRP Line Name dropdown (shortcode = STLName). */
  objectGroups: { objGroupShortcode: string; objGroupName: string }[] = [];
  readonly lineAutoSources = LINE_AUTO_SOURCES;
  readonly lineAutoConditions = LINE_AUTO_CONDITIONS;
  readonly timelineMarkerOptions = TIMELINE_MARKER_OPTIONS;

  isObjGrpRow(row: FormGroup | null | undefined): boolean {
    return String(row?.get('STType')?.value ?? '').trim().toUpperCase() === 'OBJGRP';
  }

  /** Keep a saved shortcode visible even if that object group was later deleted. */
  objectGroupSelectOptions(raw: string | null | undefined): { objGroupShortcode: string; objGroupName: string }[] {
    const opts = [...this.objectGroups];
    const v = String(raw ?? '').trim();
    if (!v) return opts;
    if (opts.some((o) => String(o.objGroupShortcode).trim().toLowerCase() === v.toLowerCase())) return opts;
    return [...opts, { objGroupShortcode: v, objGroupName: `${v} (saved)` }];
  }

  timelineMarkerSelectOptions(raw: string | null | undefined): { label: string; value: string }[] {
    const v = String(raw ?? '').trim();
    if (!v) return this.timelineMarkerOptions;
    if (this.timelineMarkerOptions.some((o) => o.value === v)) return this.timelineMarkerOptions;
    return [...this.timelineMarkerOptions, { label: `${v} (saved)`, value: v }];
  }

  readingMaterialSelectOptions(raw: string | null | undefined): { ValidVal: string }[] {
    const opts = [{ ValidVal: 'N' }, ...this.readingMaterialTypes];
    const v = String(raw ?? '').trim();
    if (!v) return opts;
    if (opts.some((o) => o.ValidVal.toLowerCase() === v.toLowerCase())) return opts;
    return [...opts, { ValidVal: v }];
  }
  shortcode: string = '';
  private unsavedWired = false;

  groupVisibility = {
    group1: true,
    group2: true,
    group3: true,
    group4: true,
    group5: true,
    group6: true,
    group7: true,
    // add others like group2: false, group3: true etc.
  };

  constructor(
    private fb: FormBuilder,
    private SlideTypeLinesService: SlideTypeLinesService,
    private objectGroupService: ObjectGroupService,
    private route: ActivatedRoute,
    private router: Router,
    private unsaved: UnsavedChangesService,
    private templateService: TemplateService
  ) { }
  ngOnInit() {
//    debugger;
    this.initForm();
   this.shortcode =  this.route.snapshot.params['slideTypeShortcode'];

    this.objectGroupService.getobjectGroupList().subscribe({
      next: (rows) => {
        const list = Array.isArray(rows) ? rows : [];
        this.objectGroups = list
          .map((r: any) => ({
            objGroupShortcode: String(r?.objGroupShortcode ?? '').trim(),
            objGroupName: String(r?.objGroupName ?? '').trim(),
          }))
          .filter((r) => r.objGroupShortcode)
          .sort((a, b) => a.objGroupShortcode.localeCompare(b.objGroupShortcode));
      },
      error: () => {
        this.objectGroups = [];
      },
    });

    this.SlideTypeLinesService.getSlideTypeMasterCodes("SLT").subscribe(types => {
       console.log('SLT');
      console.log(types);
      this.stTypes = types;
    });
    console.log(this.stTypes);
    this.SlideTypeLinesService.getSlideTypeMasterCodes("STYP").subscribe(types => {
      console.log('STYP');
      console.log(types);
      this.sourceTypes = types;
    });
    console.log(this.sourceTypes);
    this.SlideTypeLinesService.getSlideTypeMasterCodes("SHPTYP").subscribe(types => {
      console.log('SHPTYP');
      console.log(types);
      this.shapeTypes = types;
    });
     console.log(this.shapeTypes);
     this.SlideTypeLinesService.getSlideTypeMasterCodes("ENTRYANIMTYP").subscribe(types => {
      this.entryanimTypes = types;
    });
     console.log(this.entryanimTypes);
      this.SlideTypeLinesService.getSlideTypeMasterCodes("EXITANIMTYP").subscribe(types => {
      this.exitanimTypes = types;
    });
     console.log(this.exitanimTypes);

this.SlideTypeLinesService.getSlideTypeMasterCodes("TEXTALIGNTYP").subscribe(types => {
      this.textalignTypes = types;
    });
     console.log(this.textalignTypes);

     this.SlideTypeLinesService.getSlideTypeMasterCodes("BORDERTYP").subscribe(types => {
      this.shapeBorderTypes = types;
    });
     console.log(this.shapeBorderTypes);
     this.SlideTypeLinesService.getSlideTypeMasterCodes("SHADOWTYP").subscribe(types => {
      this.shapeShadowTypes = types;
    });
     console.log(this.shapeShadowTypes);
    this.templateService.getReadingMaterialTypes().subscribe((types) => {
      this.readingMaterialTypes = Array.isArray(types) ? types : [];
    });

    //objGroupShortcode,slideTypeName,slideTypeRemarks
    this.SlideTypeLinesService.getslideTypeWithSC(this.shortcode).subscribe(data => {
      let stsc = data[0];
      this.SlideTypeLines.patchValue({
       slideTypeShortcode: stsc.slideTypeShortcode,
       slideTypeName: stsc.slideTypeName,
       slidetypeRemarks: stsc.slidetypeRemarks,
       slideLayoutShortcode: stsc.slideLayoutShortcode,
       ReadingMaterial: stsc.ReadingMaterial || '',
      });
    });

    this.SlideTypeLinesService.getslideTypeLinesByShortCode(this.shortcode).subscribe(rows => {
     
      this.details.clear();
      rows.forEach((row: any) => {
        console.log(row);
        this.details.push(this.createDetailRow(row));
      });
      console.log(this.details);

      this.SlideTypeLines.markAsPristine();
      this.unsaved.setDirty(false);
      if (!this.unsavedWired) {
        this.unsavedWired = true;
        this.SlideTypeLines.valueChanges.subscribe(() => {
          if (this.SlideTypeLines.dirty) {
            this.unsaved.setDirty(true);
          }
        });
      }
    });
  }

  initForm() {
    this.SlideTypeLines = this.fb.group({
     slideTypeShortcode: [{ value: '', disabled: true }],
     slideTypeName: [''],
   slidetypeRemarks: [''],
     slideLayoutShortcode:[''],
     ReadingMaterial: [''],
      details: this.fb.array([])
    });
  }

  get details(): FormArray {
    return this.SlideTypeLines.get('details') as FormArray;
  }

  createDetailRow(row?: any): FormGroup {
    return this.fb.group({
      STlineSrno: [row?.STlineSrno || 1],
      STType: [row?.STType || ''],
      STName: [row?.STLName || ''],
      //group1: this.fb.group({
        STVal: [row?.STVal || ''],
        STSourceType: [row?.STSourceType || ''],
        STAllowTranslate: [row?.STAllowTranslate || 'Y'],
        STTextBreak: [row?.STTextBreak ?? null],
        ReadingMaterial: [row?.ReadingMaterial || ''],
      //}),
      //group2: this.fb.group({
        STShapeType: [row?.STShapeType || ''],
        STShapeBorder: [row?.STShapeBorder || ''],
        STShapeFill: [row?.STShapeFill || ''],
        STShapeShadow: [row?.STShapeShadow || ''],
      //}),
      //group3: this.fb.group({
        STtextAlign: [row?.STtextAlign || ''],
        STTextFont: [row?.STTextFont || ''],
         STTextColor: [row?.STTextColor || ''],
          STBulletFlag: [row?.STBulletFlag || ''],
           STBulletSize: [row?.STBulletSize || ''],
            STBulletCharacter: [row?.STBulletCharacter || ''],
            STNumTextStyle: [row?.STNumTextStyle || ''],
      //}),
      //group4: this.fb.group({
        STGroupColorFlag: [row?.STGroupColorFlag || ''],
        STGroupTraverseFlag: [row?.STGroupTraverseFlag || ''],
       STRowReverseFlag: [row?.STRowReverseFlag || ''],
       STOverlapFlag: [row?.STOverlapFlag || ''],
       STFixedSizeFlag: [row?.STFixedSizeFlag || ''],
       STMaxRows: [row?.STMaxRows || null],
       STMaxCols: [row?.STMaxCols || null],
      //}),
      //group5: this.fb.group({
        STXpos: [row?.STXpos || null],
        STYpos: [row?.STYpos || null],
        STWidth: [row?.STWidth || null],
        STHeight: [row?.STHeight || null],
      //}),
      //group6: this.fb.group({
        STEntryAnimType: [row?.STEntryAnimType || ''],
        STExitAnimType: [row?.STExitAnimType || ''],
        STExitAnimTime: [row?.STExitAnimTime || ''],
        STPreviousFlag: [row?.STPreviousFlag || ''],
        STNextFlag: [row?.STNextFlag || ''],
        STReplayFlag: [row?.STReplayFlag || ''],
        STAutoSource: [row?.STAutoSource || ''],
        STAutoVal: [row?.STAutoVal ?? ''],
        STAutoCondition: [row?.STAutoCondition || ''],
        STAutoloopGroup: [row?.STAutoloopGroup !== undefined && row?.STAutoloopGroup !== null ? Number(row.STAutoloopGroup) : 0],
        STAutoEntryBefore: [row?.STAutoEntryBefore || ''],
        STAutoEntryAfter: [row?.STAutoEntryAfter || ''],
        STAutoExitBefore: [row?.STAutoExitBefore || ''],
        STAutoExitAfter: [row?.STAutoExitAfter || ''],
        
      //})

      // Add group2, group3 etc. later
    });
  }

  addRow() {
    this.details.push(this.createDetailRow());
  }

  deleteRow(index: number) {
    this.details.removeAt(index);
  }

  moveUp(index: number) {
    if (index > 0) {
      const array = this.details;
      const current = array.at(index);
      array.removeAt(index);
      array.insert(index - 1, current);
    }
  }

  moveDown(index: number) {
    const array = this.details;
    if (index < array.length - 1) {
      const current = array.at(index);
      array.removeAt(index);
      array.insert(index + 1, current);
    }
  }  
  saveST(): void {
    //let newslideType : slideType;

    if (this.SlideTypeLines.valid) {
      const payload = this.SlideTypeLines.getRawValue();
      console.log( payload);
       this.SlideTypeLinesService.saveslideType(payload).subscribe(() => {
      this.SlideTypeLines.markAsPristine();
      this.unsaved.setDirty(false);
      this.router.navigate(['/designer/slide-type-list']);
    });
    }
  }
}
